/** Client-side JWT exp read (no signature verify; same pattern as api.ts org id read). */
export function getJwtExpSeconds(token: string): number | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return typeof payload.exp === 'number' ? payload.exp : null;
  } catch {
    return null;
  }
}

export function isFieldTokenExpired(token: string | null, skewSeconds = 120): boolean {
  if (!token) return true;
  const exp = getJwtExpSeconds(token);
  if (exp == null) return true;
  return Date.now() >= (exp - skewSeconds) * 1000;
}

/** Full reload so FieldAuth and all state reset. */
export function clearFieldLocalSession(): void {
  localStorage.removeItem('fieldUser');
  localStorage.removeItem('fieldToken');
}

export function redirectFieldToLoginAfterAuthFailure(
  status: number,
  body: { code?: string; message?: string } | null
): boolean {
  if (status === 401) {
    clearFieldLocalSession();
    window.location.href = '/web/field/login';
    return true;
  }
  if (status === 403 && body?.code === 'SUBSCRIPTION_EXPIRED') {
    if (typeof window !== 'undefined') {
      window.alert(
        'Bağlı bulunduğunuz organizasyonun abonelik süresi dolmuştur. İşleme devam edilemez.'
      );
    }
    clearFieldLocalSession();
    window.location.href = '/web/field/login';
    return true;
  }
  return false;
}

export async function parseJsonSafe(res: Response): Promise<any | null> {
  try {
    const text = await res.text();
    if (!text || !text.trim()) return null;
    return JSON.parse(text);
  } catch {
    return null;
  }
}
